import { connect, mapProps } from '@formily/react';
import { CnRating as UiCnRating } from "../../components/cn-rating";
import { mapSize, mapStatus } from "../__builtins__";
export var CnRating = connect(UiCnRating, mapProps(mapSize, mapStatus));
CnRating.displayName = 'CnRating';
